import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { CardContent, Stepper, Step, StepLabel } from "@mui/material";
import {
  MainContainer,
  ContentWrapper,
  StepperContainer,
  StyledCard,
} from "./styles/StyledComponents";
import Header from "./components/Header";
import BenefitCards from "./components/BenefitCards";
import PersonalDataStep from "./components/steps/PersonalDataStep";
import PropertyDetailsStep from "./components/steps/PropertyDetailsStep";
import { STEPS, INITIAL_FORM_DATA, INITIAL_ERRORS } from "./constants";
import { useFormRCAutoDetails } from "../../../rcautoContext";

function Casa() {
  const { formState } = useFormRCAutoDetails();
  const [casaStep, setCasaStep] = useState(0);
  const [errors, setErrors] = useState(INITIAL_ERRORS);
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);

  // Precompila i campi con i dati del cliente
  useEffect(() => {
    if (formState?.cliente) {
      const cliente = formState.cliente;
      const updates = {};

      if (cliente.nome) updates.nome = cliente.nome;
      if (cliente.cognome) updates.cognome = cliente.cognome;
      if (cliente.email) updates.email = cliente.email;
      if (cliente.telefono) updates.telefono = cliente.telefono;
      
      // Mappa la provincia del cliente
      if (cliente.slResProvincia) {
        updates.provincia = cliente.slResProvincia;
      }
      
      // Mappa l'indirizzo del cliente con tipologia via
      if (cliente.slResIndirizzo) {
        let indirizzo = "";
        
        // Aggiungi la tipologia della via se presente (Via, Viale, ecc.)
        if (cliente.slResIndirizzoVia) {
          if (typeof cliente.slResIndirizzoVia === "object" && cliente.slResIndirizzoVia.label) {
            indirizzo = cliente.slResIndirizzoVia.label + " ";
          } else {
            indirizzo = cliente.slResIndirizzoVia + " ";
          }
        }
        
        indirizzo += cliente.slResIndirizzo;
        
        if (cliente.slResCivico) {
          indirizzo += " " + cliente.slResCivico;
        }
        
        updates.indirizzo = indirizzo;
      }

      if (Object.keys(updates).length > 0) {
        setFormData((prev) => ({ ...prev, ...updates }));
      }
    }
  }, [formState?.cliente]);

  const handleInputChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };

  const handleCheckboxChange = (field) => (event) => {
    setFormData({
      ...formData,
      garanzie: { ...formData.garanzie, [field]: event.target.checked },
    });
  };

  const handleReset = () => {
    setFormData(INITIAL_FORM_DATA);
    setErrors(INITIAL_ERRORS);
  };

  const handleContinua = () => {
    const newErrors = {
      nome: !formData.nome,
      cognome: !formData.cognome,
      email: !formData.email,
      telefono: !formData.telefono,
    };

    setErrors(newErrors);

    if (Object.values(newErrors).some((error) => error)) {
      return;
    }

    console.log("Form data:", formData);
    setCasaStep(1);
  };

  const handleIndietro = () => {
    if (casaStep > 0) {
      setCasaStep(casaStep - 1);
    }
  };

  const handleSubmitPreventivo = () => {
    const newErrors = {
      ...errors,
      tipoAbitazione: !formData.tipoAbitazione,
      metriQuadri: !formData.metriQuadri,
      annoCostruzione: !formData.annoCostruzione,
    };

    setErrors(newErrors);

    if (
      newErrors.tipoAbitazione ||
      newErrors.metriQuadri ||
      newErrors.annoCostruzione
    ) {
      return;
    }

    console.log("Preventivo Casa richiesto:", formData);
    setCasaStep(0);
  };

  return (
    <MainContainer>
      <ContentWrapper>
        <Helmet title="Polizza Casa" />

        <Header />

        <StepperContainer>
          <Stepper
            activeStep={casaStep}
            sx={{ mb: 4, maxWidth: 500, mx: "auto" }}
          >
            {STEPS.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          <StyledCard>
            <CardContent sx={{ p: 4 }}>
              {casaStep === 0 && (
                <PersonalDataStep
                  formData={formData}
                  errors={errors}
                  handleInputChange={handleInputChange}
                  handleContinua={handleContinua}                  onReset={handleReset}                />
              )}

              {casaStep === 1 && (
                <PropertyDetailsStep
                  formData={formData}
                  errors={errors}
                  handleInputChange={handleInputChange}
                  handleCheckboxChange={handleCheckboxChange}
                  handleIndietro={handleIndietro}
                  handleSubmitPreventivo={handleSubmitPreventivo}
                  onReset={handleReset}
                />
              )}
            </CardContent>
          </StyledCard>
        </StepperContainer>

        <BenefitCards />
      </ContentWrapper>
    </MainContainer>
  );
}

export default Casa;
